import type { SDKStorage } from "@nebula-sdk/core";

// 本地存储
const localStorage: SDKStorage = {
  getItem: (key) => {
    const value = window.localStorage.getItem(key);
    if (!value) return null;
    return JSON.parse(value) as unknown;
  },
  setItem: (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key) => {
    window.localStorage.removeItem(key);
  },
  clear: () => {
    window.localStorage.clear();
  },
};

export default localStorage;
